import { Box } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import styles from './ContactsPressView.module.scss'
import classNames from 'classnames'

function ContactPressView({ content }) {
  return (
    <Box className={styles['contacts-container']}>
      <Typography
        component="h2"
        className={classNames(styles.title, 'headingMd lg:displayMd font-medium! lg:font-bold!')}
        content={'Contacts'}
      />
      <Typography content={content} variant="bodySm" />
    </Box>
  )
}

export { ContactPressView }
